export default "__VITE_ASSET__htMzc_z$__"